import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export const MAX_IMAGE_MB = 8;
export const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp,image/gif";
const ALLOWED = IMAGE_ACCEPT.split(",");

// Validates and uploads each file independently; returns URLs of the ones that succeeded.
export async function uploadImageFiles(files) {
  const urls = [];
  for (const file of files) {
    if (!ALLOWED.includes(file.type)) {
      toast.error(`"${file.name}": formato no permitido. Usa JPG, PNG, WEBP o GIF.`);
      continue;
    }
    if (file.size > MAX_IMAGE_MB * 1024 * 1024) {
      toast.error(`"${file.name}" pesa ${(file.size / 1048576).toFixed(1)} MB. El máximo es ${MAX_IMAGE_MB} MB por foto.`);
      continue;
    }
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/business/upload-image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      urls.push(data.url);
    } catch (e) {
      toast.error(`"${file.name}": ${formatApiErrorDetail(e.response?.data?.detail) || "no se pudo subir"}`);
    }
  }
  return urls;
}
